import { render, staticRenderFns } from "./epms2030.vue?vue&type=template&id=71f9b52e&scoped=true"
import script from "./epms2030.vue?vue&type=script&lang=js"
export * from "./epms2030.vue?vue&type=script&lang=js"
import style0 from "./epms2030.vue?vue&type=style&index=0&id=71f9b52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9b52e",
  null
  
)

export default component.exports